import axios from '@/components/api/axios';

async function getDiscountInfo(data) {
  const res = await axios.axiosPost('/api/purchaseWallet/getDiscountInfo', data);
  return res;
}

async function confirmOrder(orderData) {
  const res = await axios.axiosPost('/api/purchaseWallet/confirmOrder', orderData);
  return res;
}

async function createOrder(orderData) {
  const res = await axios.axiosPost('/api/purchaseWallet/createOrder', orderData);
  return res;
}

async function getDeliveryDateTimeList(orderData) {
  const res = await axios.axiosPost('/api/purchaseWallet/getPossibleDeliveryDateTimeList', orderData);
  return res;
}

export default {
  getDiscountInfo,
  confirmOrder,
  createOrder,
  getDeliveryDateTimeList
}



// WEBPACK FOOTER //
// ./src/components/api/purchase/purchaseWallet.js